import { render, staticRenderFns } from "./Prestation.vue?vue&type=template&id=998745aa&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./Prestation.vue?vue&type=script&lang=js"
export * from "./Prestation.vue?vue&type=script&lang=js"
import style0 from "./Prestation.vue?vue&type=style&index=0&id=998745aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports